export const RETENTION_CSV = `CHURN_TIME,RETENTION_AGG,MOVING_AVG_RETENTION
17,1.992018500000,1.992018500000000
18,3.805420000000,2.898719250000000
19,5.982801750000,3.926746750000000
20,7.429853250000,4.802523375000000
21,9.384090500000,6.650541375000000
22,11.991723500000,8.697117250000000
23,13.265478500000,10.517786437500000
24,12.978120500000,11.904853250000000
25,11.702716500000,12.484509750000000
26,11.812982750000,12.439824562500000
27,11.196768750000,11.922647125000000
28,10.983982750000,11.424112687500000
29,11.047576750000,11.260327750000000
30,10.487538500000,10.928966687500000
31,10.900767500000,10.854966375000000
32,9.917815250000,10.588424500000000
33,10.483098250000,10.447304875000000
34,10.038083250000,10.334941062500000
35,8.634553250000,9.768387500000000
36,7.212956500000,9.092172812500000
37,4.189557250000,7.518787562500000
38,3.420831500000,5.864474625000000
39,2.712695750000,4.384010250000000
40,1.870682500000,3.048441750000000
41,0.818592500000,2.205700562500000`;
